import React, { Component } from 'react'
import moment from 'moment'

const today = moment().utc().startOf('day').unix()

class MemberItem extends Component {
  cssClass (m, s) {
    let unpaid = ' unpaid'
    if (m.last_paid !== '') {
      if (m.last_paid >= today) {
        unpaid = ''
      }
    }
    return 'row-item selectable ' +
      m.course_color +
      ((s === m.id) ? ' selected' : '') + unpaid
  }
  render () {
    const m = this.props.member
    const s = this.props.selected
    return (
      <ul className={this.cssClass(m, s)} onClick={() => this.props.showCalendar(m)}>
        <li className="member-avatar">
          <img src={m.avatar} alt={m.name + ' ' + m.surname} className="avatar" />
        </li>
        <li>
          <span>Nome</span>
          {m.name} {m.surname}
        </li>
        <li>
          <span>Età</span>
          {m.age}
        </li>
        <li>
          <span>Tshirt</span>
          {m.tshirt_size}
        </li>
      </ul>
    )
  }
}

export default MemberItem



// WEBPACK FOOTER //
// ./src/components/Attendances/MemberItem.js